import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-footer',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './footer.component.html',
})
export class FooterComponent {
  // Mantém em sincronia com a "version" do package.json a cada release.
  version = '2.1.1';
}
